import React from 'react';

export default function SearchBox({ value, onChange, onClear, placeholder = 'Search...', className = '' }) {
  return (
    <div className={`search-box ${className}`}>
      <svg className="search-box-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14ZM18 18l-4.35-4.35"
          stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
      <input
        className="search-box-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button type="button" className="search-box-clear" aria-label="Clear search" onClick={onClear}>
          ×
        </button>
      )}
    </div>
  );
}
